import React, { lazy, Suspense } from "react"
import { Switch, Route } from "react-router-dom"

import "./App.css"
import "./colors.css"

const Home = lazy(() => import("./features/home"))
const Storyboard = lazy(() => import("./features/storyboard"))

const renderLoader = () => (
  <p
    style={{
      margin: "20px auto",
      width: "max-content",
      color: "gray",
    }}
  >
    Laden...
  </p>
)

function App() {
  return (
    <Suspense fallback={renderLoader()}>
      <Switch>
        <Route path="/storyboard" component={Storyboard} />
        <Route
          path="/bestellen"
          render={() => {
            window.location.href = process.env.REACT_APP_ORDER_LINK
            return null
          }}
        />
        <Route component={Home} />
      </Switch>
    </Suspense>
  )
}

export default App
